<template>
  <div>
    <!-- 悬浮窗 -->
    <div
      id="page-ai-help-slider"
      class="ai-help-btn-class b-r-8"
      v-draggable="updatePosition"
      @click="toggleAiHelp"
      :style="{ right: `4px`, top: `${position.y}px` }"
    >
      <!-- <a-tooltip class="max-icon" placement="left" title="AI助手"> -->
      <div :class="{ active: showAiHelp }" class="ai-assistant-btn b-r-8">
        <tw-icons icon-type="ai-help" />
        <div class="ai-title">AI助手</div>
      </div>
      <!-- </a-tooltip> -->
    </div>
    <div class="ai-help-class" v-show="showAiHelp" :style="getDialogStyle()">
      <a-spin :spinning="isIframeLoaded" tip="Loading..." style="width: 500px; height: 600px">
        <iframe
          @load="onIframeLoaded"
          :src="aiHelpUrl"
          @error="onIframeError"
          frameborder="0"
          style="width: 500px; height: 600px"
        ></iframe>
      </a-spin>
    </div>
  </div>
</template>

<script>
import TwIcons from '@/components/tw-icons'

export default {
  components: { TwIcons },
  data () {
    return {
      showAiHelp: false,
      position: {
        x: 6, // 初始位置
        y: 600
      },
      isIframeLoaded: true, // 控制iframe是否加载完成
      aiHelpUrl: `https://ai.talkweb.com.cn/chat/share?shared_id=d5293e241f5b11f0ac85560fe98e6544&from=chat&auth=ViNDQ2ZjY0MjBlMzExZjA5NTc5NTYwZm`
    }
  },

  methods: {
    onIframeLoaded () {
      this.isIframeLoaded = false // iframe加载完成后设置为true
    },
    onIframeError () {
      console.error('error')
    },
    toggleAiHelp () {
      const btn = document.querySelector('#page-ai-help-slider')
      const isDraggable = btn && btn.getAttribute('isDraggable')
      if (isDraggable === 'true') {
        return
      }
      this.showAiHelp = !this.showAiHelp
    },
    updatePosition (newPos) {
      this.position = newPos
    },
    getDialogStyle () {
      const { y } = this.position
      const dialogHeight = 540 // 对话框的高度
      const buttonHeight = 0 // 按钮的高度

      let top

      if (y + dialogHeight > window.innerHeight) {
        // 按钮靠下，对话框显示在上边
        top = Math.max(y - dialogHeight - buttonHeight, 0)
      } else {
        // 按钮靠上，对话框显示在下边
        top = y + buttonHeight
      }

      return {
        right: '-160px',
        top: `${top}px`
      }
    },
    handleOutsideClick (event) {
      const dialog = document.querySelector('.ai-help-class')
      const button = document.querySelector('#page-ai-help-slider')

      // 如果点击的位置不在对话框或按钮内，则关闭对话框
      if (this.showAiHelp && !dialog.contains(event.target) && !button.contains(event.target)) {
        this.showAiHelp = false
      }
    }
  },
  mounted () {
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleOutsideClick)
    // const protocol = window.location.protocol
    // const domain = window.location.hostname // 'it.dev-paas.talkweb.com.cn'
    // this.aiHelpUrl = `${protocol}//ai.${domain}/chat/share?shared_id=d5293e241f5b11f0ac85560fe98e6544&from=chat&auth=ViNDQ2ZjY0MjBlMzExZjA5NTc5NTYwZm`
  },
  beforeDestroy () {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleOutsideClick)
  }
}
</script>

<style lang="less" scoped>
.ai-help-btn-class {
  position: fixed;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  background-color: @primary-color;
  border: 1px solid #eaeaea;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  &:hover {
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
    transform: scale(1.05);
    color: @primary-color;
    background-color: rgba(0, 128, 255, 0.1);
  }
  &.active {
    background-color: rgba(0, 128, 255, 0.1);
    color: @primary-color;
    border: 1px solid rgba(0, 128, 255, 0.2);
  }
}

.ai-assistant-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .ai-title {
    margin-top: 5px;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
  }
}
.ai-help-class {
  position: absolute;
  z-index: 99998;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  background-color: #fff;
  &:hover {
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  }
}
</style>
